import React from "react";
import { useTranslation } from "@/translations/TranslationContext";
import aboutempower1 from "@/assets/about-values.png";

function ValuesShape() {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="valuesshape mb150_75">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <span className="chips">{t.about.values.chips}</span>
              <h2>
                {t.about.values.title}
              </h2>
            </div>
            <div className="col-lg-6">
              <p className="text24 mb38 valuesshapetext">
                {t.about.values.subtitle}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-6">
                  <div className="vtsbox">
                    <div className="numb">01</div>
                    <h4>{t.about.values.value1.title}</h4>
                    <p>
                      {t.about.values.value1.description}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="vtsbox">
                    <div className="numb">02</div>
                    <h4>{t.about.values.value2.title}</h4>
                    <p>
                      {t.about.values.value2.description}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="vtsbox">
                    <div className="numb">03</div>
                    <h4>{t.about.values.value3.title}</h4>
                    <p>
                      {t.about.values.value3.description}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="vtsbox">
                    <div className="numb">04</div>
                    <h4>{t.about.values.value4.title}</h4>
                    <p>
                      {t.about.values.value4.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                className="valuesshapeimg"
                src={aboutempower1}
                alt="about-values"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ValuesShape;
